type InfoboxProps = {
	children: React.ReactNode;
	type?: 'primary' | 'secondary' | 'tertiary' | 'warning';
};

export default function Infobox({ children, type = 'primary' }: InfoboxProps) {
	return (
		<div className="feature__infobox">
			<div className={`infobox infobox--${type}`}>
				<p>{children}</p>
			</div>
		</div>
	);
}
